// filepath: /Users/macncheese/Desktop/AnamVR/AnamVR-Web/components/CookiesBanner.tsx
import { useState, useEffect } from "react";
import { X, Cookie } from "lucide-react";

const CookiesBanner = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [isClosing, setIsClosing] = useState(false);

  useEffect(() => {
    // Check if user has already made a choice
    const cookieConsent = localStorage.getItem("cookieConsent");
    if (!cookieConsent) {
      // Show banner after a short delay for better UX
      const timer = setTimeout(() => {
        setIsVisible(true);
      }, 1000);
      return () => clearTimeout(timer);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem("cookieConsent", "accepted");
    localStorage.setItem("cookieConsentDate", new Date().toISOString());
    closeBanner();

    // Here you can add analytics tracking or other cookie-dependent functionality
    // Example: Enable Google Analytics, Facebook Pixel, etc.
    console.log("Cookies accepted - enabling tracking");
  };

  const handleReject = () => {
    localStorage.setItem("cookieConsent", "rejected");
    localStorage.setItem("cookieConsentDate", new Date().toISOString());
    closeBanner();

    // Here you can disable non-essential cookies
    console.log("Cookies rejected - disabling non-essential tracking");
  };

  const closeBanner = () => {
    setIsClosing(true);
    setTimeout(() => {
      setIsVisible(false);
      setIsClosing(false);
    }, 300);
  };

  if (!isVisible) return null;

  return (
    <>
      <div
        className={`fixed inset-0 bg-black/20 z-40 transition-opacity duration-300 ${
          isClosing ? "opacity-0" : "opacity-100"
        }`}
      />

      {/* Cookie Banner */}
      <div
        className={`fixed min-w-full bottom-0 left-0 right-0 z-50 transition-all duration-300 ease-out ${
          isClosing ? "translate-y-full opacity-0" : "translate-y-0 opacity-100"
        }`}
      >
        <div className="max-w-full mx-auto">
          <div className="bg-white rounded-t-2xl shadow-2xl border border-gray-200 p-6 sm:py-8 sm:px-12 lg:py-14 lg:px-20">
            <div className="flex flex-col md:flex-row items-start md:items-center gap-6">
              <div className="flex-shrink-0">
                <div className="w-12 h-12 bg-[#7745b8]/10 rounded-full flex items-center justify-center">
                  <Cookie className="w-6 h-6 text-[#7745b8]" />
                </div>
              </div>

              {/* Content */}
              <div className="flex-1">
                <h3 className="text-xl font-semibold text-gray-900 mb-2">
                  We Value Your Privacy
                </h3>
                <p className="text-gray-600 text-sm md:text-base leading-relaxed mb-4 md:mb-0">
                  We use cookies to improve site functionality and understand
                  how you interact with our content. We do not use analytics or
                  marketing cookies. By clicking “Accept All”, you agree to our{" "}
                  <a
                    href="/privacy-policy"
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label="Privacy Policy"
                    className="text-[#7745b8] hover:text-[#5a3a9a] underline font-medium"
                  >
                    Privacy Policy
                  </a>
                  .
                </p>
              </div>

              {/* Actions */}
              <div className="flex flex-col sm:flex-row gap-3 w-full md:w-auto">
                <button
                  onClick={handleReject}
                  className="px-6 py-3 text-gray-600 bg-gray-100 hover:bg-gray-200 rounded-lg font-medium transition-colors duration-200 text-sm md:text-base whitespace-nowrap"
                >
                  Reject All
                </button>
                <button
                  onClick={handleAccept}
                  className="px-6 py-3 bg-[#7745b8] hover:bg-[#5a3a9a] text-white rounded-lg font-medium transition-colors duration-200 text-sm md:text-base whitespace-nowrap"
                >
                  Accept All
                </button>
              </div>
            </div>

            {/* Additional options */}
            {/* <div className="mt-6 pt-4 border-t border-gray-100">
              <div className="flex flex-wrap gap-4 text-sm">
                <button
                  onClick={() => {
                    // You can implement a detailed preferences modal here
                    console.log("Manage preferences clicked");
                  }}
                  className="text-[#7745b8] hover:text-[#5a3a9a] font-medium underline"
                >
                  Manage Preferences
                </button>
                <span className="text-gray-400">•</span>
                <span className="text-gray-500">
                  Essential cookies are always enabled
                </span>
              </div>
            </div> */}
          </div>
        </div>
      </div>
    </>
  );
};

export default CookiesBanner;
